const template = require('./index.html.slim');
const controller = require('./portfolio_models_controller.js');

const directive = {
  replace: true,
  restrict: 'E',
  templateUrl: template,
  controller,
  controllerAs: 'ctrl',
  link($scope, $el, $attrs) {
    return window.addEventListener('scroll', function(e) {
      if (window.scrollY > 111) {
        return $el.addClass('fixed');
      } else {
        return $el.removeClass('fixed');
      }
    });
  },
};

angular.module('wbComponents').directive('portfolioModels', () => directive);
